import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
// material
import { Stack, TextField, IconButton, InputAdornment, Button, Snackbar } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// component
import Iconify from '../../../components/Iconify';
import { api } from 'src/Api';
import Alert from '@mui/material/Alert';

export default function ChangePasswordForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, token, code, email, message, from } = location.state || {};
  // const [email, setemail] = useState('');
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  useEffect(() => {
    // setemail(localStorage.getItem('email'));
  }, []);

  const RegisterSchema = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('password')], 'New Password and Confirm Password do not match.')
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      setPassword();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;
  const [loading, setloading] = useState(false);
  const [disabled, setdisabled] = useState(false);

  function setPassword() {
    if (values.password === values?.confirmPassword) {
      var formdata = new FormData();
      formdata.append('email', email);
      formdata.append('password', values?.password);
      // formdata.append('password_confirmation', values?.confirmPassword);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };

      setloading(true);

      fetch(api.updateforgotpassword, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return response.json().then((error) => {
              setalert({ visible: true, message: error.message });
            });
          }
        })
        .then((result) => {
          if (result.success == true) {
            setSnackbarOpen(true);
            setSnackbarMessage(result.message);
            setSnackbarSeverity('success');
            // setalert({ visible: true, message: result.message });
            localStorage.clear();
            setTimeout(() => {
              navigate('/login', { replace: true });
            }, 2000);
          } else {
            setSnackbarOpen(true);
            setSnackbarMessage(result.message);
            setSnackbarSeverity('error');
            setalert({ visible: true, message: result.message });
          }
        })
        .catch((error) => {
          console.log(error);
          // setalert({ visible: true, message: error.message });
        })
        .finally(() => {
          setloading(false);
        });
    } else {
      setalert({ visible: true, message: 'New Password and Confirm Password do not match' });
    }
  }

  const [showPassword, setshowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            label="New Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setshowPassword(!showPassword);
                    }}
                    edge="end"
                  >
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />

          <TextField
            fullWidth
            type={showConfirmPassword ? 'text' : 'password'}
            label="Confirm Password"
            {...getFieldProps('confirmPassword')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setShowConfirmPassword(!showConfirmPassword);
                    }}
                    edge="end"
                  >
                    <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            helperText={touched.confirmPassword && errors.confirmPassword}
          />
          <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>

          {alert.visible && (
            <Alert
              onClose={() => {
                setalert({ visible: false, message: '' });
              }}
              severity={alert.message.includes('updated') ? 'success' : 'error'}
            >
              {alert.message}
            </Alert>
          )}

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            disabled={disabled}
          >
            Save
          </LoadingButton>
          <LoadingButton
            style={{ marginTop: 10 }}
            fullWidth
            size="large"
            variant="outlined"
            onClick={() => {
              navigate('/login', { replace: true });
            }}
          >
            Login
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
